var map = {
	"./dhjh.svg": 97043,
	"./dzd.svg": 29860,
	"./gkqy.svg": 24519,
	"./gxgl.svg": 57222,
	"./khdd.svg": 19088,
	"./khns.svg": 73271,
	"./logo.svg": 11804,
	"./qysz.svg": 47932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78131;